import React from "react";
import { ChevronIcon } from "../../Icons";
import * as S from "./BackLink.styles";
import { ButtonLinkComponentProps } from "../Link";

export type BackLinkBaseProps = ButtonLinkComponentProps & {
  /** Back link label */
  backText?: React.ReactNode;
  /** Destination label */
  destinationText?: React.ReactNode;
  /** Optionally you can fully control the text displayed on the link by passing
   * down children. The content will include by default the chevron icon. */
  children?: React.ReactNode;
};

export const BackLink = ({
  backText,
  destinationText,
  children,
  ...props
}: BackLinkBaseProps) => {
  return (
    <S.Layout {...props} analyticId="back_link">
      <ChevronIcon direction="left" aria-hidden="true" />
      {children || (
        <>
          {backText} {destinationText}
        </>
      )}
    </S.Layout>
  );
};
